import type { ReactNode } from 'react';
import { HEADER_HOSTING_MIN_HEIGHT_CLASS } from '@/components/capability-detail/worker-hosting-header-dimensions';
import { PageTitle } from '@/components/layout/PageTitle';
import { SidebarTrigger } from '@/components/ui/sidebar';
import { cn } from '@/lib/utils';
import type { HeaderTitle } from '@/lib/header-action-context';

export function AppSidebarHeader({
    headerTitle,
    center,
    versionSelector,
    children,
}: {
    headerTitle?: HeaderTitle | null;
    center?: ReactNode;
    versionSelector?: ReactNode;
    children?: ReactNode;
}) {
    return (
        <header
            data-slot="page-header"
            className={cn(
                'relative flex shrink-0 items-center gap-2 px-4 py-2 transition-[width,height] ease-linear md:px-3',
                center ? HEADER_HOSTING_MIN_HEIGHT_CLASS : 'min-h-[8vh]',
            )}
        >
            <div className="relative z-10 flex min-w-0 flex-1 items-center gap-2">
                <SidebarTrigger className="-ml-1 shrink-0" />
                <div className="min-w-0 flex-1">
                    {headerTitle ? (
                        <PageTitle {...headerTitle} />
                    ) : null}
                </div>
            </div>
            {center ? (
                <div className="pointer-events-none absolute inset-x-0 top-0 bottom-0 flex items-center justify-center px-2">
                    <div className="pointer-events-auto mx-auto w-max max-w-[min(calc((100vw-6rem)*1.1),61.6rem)] min-w-0">
                        {center}
                    </div>
                </div>
            ) : null}
            <div className="relative z-10 flex min-w-0 flex-1 items-center justify-end gap-3">
                {versionSelector}
                {children}
            </div>
        </header>
    );
}

export default AppSidebarHeader;
